import React from 'react';
import { Link } from 'react-router-dom';
import bgimg from '../../../../assets/images/footer.png'

const Footer = () => {
    return (
        <footer style={{ backgroundImage: `url(${bgimg})`, backgroundSize: 'cover' }} className=" p-10  my-8 mx-2" >
            <div className='footer' >
                <div >
                    <span className="footer-title">Services</span>
                    <Link to='/' className="link link-hover">Emergency Checkup</Link>
                    <Link to='/' className="link link-hover">Monthly Checkup</Link>
                    <Link to='/' className="link link-hover">Weekly Checkup</Link>
                    <Link to='/' className="link link-hover">Deep Checkup</Link>
                </div>
                <div>
                    <span className="footer-title">ORAL HEALTH</span>
                    <Link to='/' className="link link-hover">Fluoride Treatment</Link>
                    <Link to='/' className="link link-hover">Cavity Filling</Link>
                    <Link to='/' className="link link-hover">Teath Whitening</Link>

                </div>
                <div>
                    <span className="footer-title">OUR ADDRESS</span>

                    <Link className="link link-hover">Privacy policy</Link>
                    <Link className="link link-hover">New York - 101010 Hudson</Link>
                </div>
            </div>
            <div className='text-center mt-6 font-bold'>
                <p>Copyright © 2022 - DentalCare.</p>
            </div>
        </footer>
    );
};

export default Footer;